import {graphql} from 'gatsby';
import * as React from 'react';

import BoxSection from '@src/components/BoxSection';
import GridOneCol from '@src/components/Grid/GridOneCol';
import GridTwoCol from '@src/components/Grid/GridTwoCol';
import PageSection from '@src/components/PageSection';

import type {BasicCardCtaFragment} from '@graphql-types';

interface BasicCardCtaProps {
  basicCardCtaContent: Pick<BasicCardCtaFragment, 'primary'>;
  noBottomPadding: boolean;
}

const BasicCardCta = ({
  basicCardCtaContent,
  noBottomPadding,
}: BasicCardCtaProps) => {
  const cardLayout = basicCardCtaContent.primary.card_layout;

  if (cardLayout === 'One Column') {
    return (
      <PageSection noBottomPadding={noBottomPadding}>
        <BoxSection theme="beige">
          <GridOneCol
            gridType="small"
            align="left"
            columnContent={{
              primary: {
                rich_text_content: basicCardCtaContent.primary.single_column,
              },
            }}
          />
        </BoxSection>
      </PageSection>
    );
  }

  if (cardLayout === 'Two Column') {
    return (
      <PageSection noBottomPadding={noBottomPadding}>
        <BoxSection theme="beige">
          <GridTwoCol
            gridType="split"
            columnContent={{
              left_column: basicCardCtaContent.primary.left_column,
              right_column: basicCardCtaContent.primary.right_column,
            }}
          />
        </BoxSection>
      </PageSection>
    );
  }
};

export default BasicCardCta;

export const basicCardCtaFragment = graphql`
  fragment basicCardCta on PrismicPageDataBodyCardCta {
    id
    slice_type
    primary {
      card_layout
      single_column {
        html
        text
      }
      left_column {
        html
        text
      }
      right_column {
        html
        text
      }
    }
  }
`;
